var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"object-fit":"cover","border-radius":"2px"},attrs:{"src":require('./330px-Flag_of_South_Africa.svg.png'),"width":"24","height":"16","alt":"South Africa"}})
}
var staticRenderFns = []

export { render, staticRenderFns }